const SvgDownArrowGrey = (props) => {
	return (
		<svg
			width="10"
			height="6"
			viewBox="0 0 10 6"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M5.00095 5.84969C4.82173 5.84969 4.64253 5.78126 4.50589 5.64469L0.206118 1.34487C-0.0674039 1.07135 -0.0674039 0.627883 0.206118 0.354472C0.479529 0.0810613 0.922909 0.0810613 1.19645 0.354472L5.00095 4.15919L8.80547 0.354605C9.07899 0.0811942 9.52232 0.0811942 9.79571 0.354605C10.0694 0.628016 10.0694 1.07148 9.79571 1.34501L5.49601 5.64482C5.3593 5.78142 5.1801 5.84969 5.00095 5.84969Z"
				fill="#999999"
			/>
		</svg>
	);
};

export default SvgDownArrowGrey;
